<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>中华人民共和国(一)<br />企业所得税月(季)度预缴纳税申报表(A类，2021年版)</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody>
          <tr>
            <td class="td-center" style="width: 150px">预缴方式</td>
            <td style="width: 300px">
              <el-radio disabled value="1" v-model="radio1">按照实际利润额预缴</el-radio>
              <!-- <input type="radio" id="radio1" name="type" disabled="disabled" value="1" checked="checked" />
              <label for="radio1">按照实际利润额预缴</label> -->
            </td>
            <td style="width: 300px">
              <el-radio disabled value="2" v-model="radio1">按照上一纳税年度应纳税所得额平均额预缴</el-radio>
              <!-- <input type="radio" id="radio2" name="type" disabled="disabled" value="2" />
              <label for="radio2">按照上一纳税年度应纳税所得额平均额预缴</label> -->
            </td>
            <td style="width: 300px">
              <el-radio disabled value="3" v-model="radio1">按照税务机关确定的其他方法预缴</el-radio>
              <!-- <input type="radio" id="radio3" name="type" disabled="disabled" value="3" />
              <label for="radio3">按照税务机关确定的其他方法预缴</label> -->
            </td>
          </tr>
          <tr>
            <td class="td-center">企业类型</td>
            <td>
              <el-radio disabled value="1" v-model="radio2">一般企业</el-radio>
              <!-- <input type="radio" id="radio1" name="cate" disabled="disabled" value="1" checked="checked" /><label for="radio1">一般企业</label> -->
            </td>
            <td>
              <el-radio disabled value="2" v-model="radio2">跨地区经营汇总纳税企业 总机构</el-radio>
              <!-- <input type="radio" id="radio2" name="cate" disabled="disabled" value="2" /><label for="radio2">跨地区经营汇总纳税企业 总机构</label> -->
            </td>
            <td>
              <el-radio disabled value="3" v-model="radio2">跨地区经营汇总纳税企业 分支机构</el-radio>
              <!-- <input type="radio" id="radio3" name="cate" disabled="disabled" value="3" /><label for="radio3">跨地区经营汇总纳税企业 分支机构</label> -->
            </td>
          </tr>
        </tbody>
      </table>
      <table class="">
        <colgroup>
          <col width="50" />
          <col />
        </colgroup>
        <thead>
          <tr class="table-head">
            <td colspan="13">优惠及附报事项有关信息</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3" rowspan="2" class="td-center">项目</td>
            <td colspan="2" class="td-center">一季度</td>
            <td colspan="2" class="td-center">二季度</td>
            <td colspan="2" class="td-center">三季度</td>
            <td colspan="2" class="td-center">四季度</td>
            <td colspan="2" rowspan="2" class="td-center"
                style="min-width: 110px;"
            >季度平均值</td>
          </tr>
          <tr>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">从业人数</td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x2.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x3.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x4.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x4.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x5.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x6" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x6.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x6.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x7" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x7.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x7.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x7.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x8.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x8.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td colspan="2" class="td-center">{{ data.v1x9.value }}</td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">资产总额（万元）</td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x6" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x7" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x7.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x7.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v2x9.value) }}</td>
          </tr>
          <tr>
            <td colspan="5" class="td-center">国家限制或禁止行业</td>
            <td colspan="2" class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v3x1.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v3x1.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v3x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                    style="max-width: 200px"
                  />
                </template>
              </taxQue>
              <!-- <label><input type="radio" name="data_h_3_1" value="1" checked="checked" style="width: 20px" />是</label>
              <label><input type="radio" name="data_h_3_1" value="-1" style="width: 20px" />否</label> -->
            </td>
            <td colspan="4" class="td-center">小型微利企业</td>
            <td colspan="2" class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v3x2.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v3x2.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v3x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                    style="max-width: 200px"
                  />
                </template>
              </taxQue>
              <!-- <label><input type="radio" name="data_h_3_2" value="1" checked="checked" style="width: 20px" />是</label>
              <label><input type="radio" name="data_h_3_2" value="-1" style="width: 20px" />否</label> -->
            </td>
          </tr>
          <tr>
            <td colspan="2" class="td-center"><b>代码</b></td>
            <td colspan="9" class="td-center"><b>附报事项名称</b></td>
            <td colspan="2" class="td-center">金额或选项</td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">D01002</td>
            <td colspan="8">支持新型冠状病毒感染的肺炎疫情防控捐赠支出金额扣除(本年累积,元)</td>
            <td colspan="2" class="td-center">
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">K01002</td>
            <td colspan="8">扶贫捐赠支出全额扣除(本年累积,元)</td>
            <td colspan="2" class="td-center">
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">Y01001</td>
            <td colspan="8">软件集成电路企业按新政策或原政策执行优惠(单选：原政策/新政策)</td>
            <td colspan="2" class="td-center">
              <el-radio-group style="flex-direction: column" v-model="data.v6x1.value">
                <el-radio value="1" style="margin: 0">原政策</el-radio>
                <el-radio value="-1">新政策</el-radio>
              </el-radio-group>

              <!-- <label><input type="radio" name="data_h_6_2" value="1" checked="checked" style="width: 20px" />原政策</label>
              <label><input type="radio" name="data_h_6_2" value="-1" style="width: 20px" />新政策</label> -->
            </td>
          </tr>
          <tr class="table-head">
            <td></td>
            <td colspan="10" class="td-center">预缴税款计算</td>
            <td colspan="2" class="td-center">本年累计</td>
          </tr>
          <tr>
            <td class="indent_1em">1</td>
            <td colspan="10">营业收入</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v7x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_1em">2</td>
            <td colspan="10">营业成本</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v8x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_1em">3</td>
            <td colspan="10">利润总额</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v9x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v9x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v9x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_1em">4</td>
            <td colspan="10">加：特定业务计算的应纳税所得额</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">5</td>
            <td colspan="10">减：不征税收入</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">6</td>
            <td colspan="10">减：资产加速折旧、摊销（扣除）调减额（填写 A201020）</td>
            <td colspan="2">{{ parseFloatNum(data.v12x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">7</td>
            <td colspan="8">减：免税收入、减计收入、加计扣除（7.1+7.2+…）</td>
            <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
            <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
            <td colspan="2">{{ parseFloatNum(data.v13x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">7.1</td>
            <td colspan="9">
              <el-select v-model="data.v14x1.value">
                <el-option-group v-for="(group, index) of options1" :label="group.label" :key="index">
                  <el-option v-for="item of group.options" :key="item.value" :label="item.label" :value="item.value" />
                </el-option-group>
              </el-select>
            </td>
            <td class="td-center">
              <!-- <label><input type="checkbox" name="lineSeven" data_id="0" style="width: 20px" /></label> -->
            </td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">7.2</td>
            <td colspan="9">
              <el-select v-model="data.v15x1.value">
                <el-option-group v-for="(group, index) of options1" :label="group.label" :key="index">
                  <el-option v-for="item of group.options" :key="item.value" :label="item.label" :value="item.value" />
                </el-option-group>
              </el-select>
            </td>
            <td class="td-center">
              <!-- <label><input type="checkbox" name="lineSeven" data_id="1" style="width: 20px" /></label> -->
            </td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">8</td>
            <td colspan="8">减：所得减免（8.1+8.2+…）</td>
            <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
            <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
            <td colspan="2">{{ parseFloatNum(data.v16x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">8.1</td>
            <td colspan="9">
              <el-select v-model="data.v17x1.value">
                <el-option v-for="(item, index) of options2" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </td>
            <td class="td-center">
              <!-- <label><input type="checkbox" name="lineEight" data_id="0" style="width: 20px" /></label> -->
            </td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v17x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">8.2</td>
            <td colspan="9">
              <el-select v-model="data.v18x1.value">
                <el-option v-for="(item, index) of options2" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </td>
            <td class="td-center">
              <!-- <label><input type="checkbox" name="lineEight" data_id="1" style="width: 20px" /></label> -->
            </td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">9</td>
            <td colspan="10">减：弥补以前年度亏损</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">10</td>
            <td colspan="10">实际利润额（3+4-5-6-7-8-9） 按照上一纳税年度应纳税所得额平均额确定的应纳税所得额</td>
            <td colspan="2">{{ parseFloatNum(data.v20x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">11</td>
            <td colspan="10">税率(25%)</td>
            <td colspan="2">{{ data.v21x1.value * 100 }}%</td>
          </tr>
          <tr>
            <td class="indent_1em">12</td>
            <td colspan="10">应纳所得税额（10×11）</td>
            <td colspan="2">{{ parseFloatNum(data.v22x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">13</td>
            <td colspan="8">减：减免所得税额（13.1+13.2+…）</td>
            <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
            <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
            <td colspan="2">{{ parseFloatNum(data.v23x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">13.1</td>
            <td colspan="9">
              <!-- 考题 -->
              <taxQue :data="data.v24x1" :mode="mode">
                <template #input>
                  <el-select v-model="data.v24x1.value">
                    <el-option-group v-for="(group, index) of options3" :label="group.label" :key="index" :value="group.value">
                      <el-option v-for="item of group.options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-option-group>
                  </el-select>
                </template>
                <template #score>
                  <el-select placeholder="请选择答案" v-model="data.v24x1.answer">
                    <el-option-group v-for="(group, index) of options3" :label="group.label" :key="index" :value="group.value">
                      <el-option v-for="item of group.options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-option-group>
                  </el-select>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- <label><input type="checkbox" name="lineThirteen" data_id="0" style="width: 20px" /></label> -->
            </td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v24x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v24x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v24x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <!-- <tr>
            <td class="indent_1em">13.2</td>
            <td colspan="9">
              <el-select v-model="data.v25x1.value">
                <el-option-group v-for="(group, index) of options3" :label="group.label" :key="index" :value="group.value">
                  <el-option v-for="item of group.options" :key="item.value" :label="item.label" :value="item.value" />
                </el-option-group>
              </el-select>
            </td>
            <td class="td-center">
              <label><input type="checkbox" name="lineThirteen" data_id="1" style="width: 20px" /></label>
            </td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr> -->
          <tr>
            <td class="indent_1em">14</td>
            <td colspan="10">减：本年实际已缴纳所得税额</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v26x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v26x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v26x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_1em">15</td>
            <td colspan="10">减：特定业务预缴（征）所得税额</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">16</td>
            <td colspan="10">本期应补（退）所得税额（12-13-14-15）税务机关确定的本期应纳所得税额</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v28x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v28x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v28x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v28x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="table-head">
            <td colspan="13" class="td-center">汇总纳税企业总分机构税款计算</td>
          </tr>
          <tr>
            <td class="indent_1em">17</td>
            <td colspan="2" rowspan="4" class="td-center">总机构</td>
            <td colspan="8">总机构本期分摊应补（退）所得税额（18+19+20）</td>
            <td colspan="2">{{ parseFloatNum(data.v29x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">18</td>
            <td colspan="8">其中：总机构分摊应补（退）所得税额（16×总机构分摊比例____%）</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v30x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">19</td>
            <td colspan="8" class="indent_2em">财政集中分配应补（退）所得税额（16×财政集中分配比例____%）</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v31x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">20</td>
            <td colspan="8" class="indent_2em">总机构具有主体生产经营职能的部门分摊所得税额（16×全部分支机构分摊比例____% ×总机构具有主体生产经营职能部门分摊比例____%)</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v32x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">21</td>
            <td colspan="2" rowspan="2" class="td-center">分支机构</td>
            <td colspan="8">分支机构本期分摊比例</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v33x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">22</td>
            <td colspan="8">分支机构本期分摊应补（退）所得税额</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v34x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="table-head">
            <td colspan="13" class="td-center">实际缴纳企业所得税计算</td>
          </tr>
          <tr>
            <td class="indent_1em">FZ1</td>
            <td colspan="10">中央级收入实际应纳税额[本期：16行*60%或（18行+20行）*60% +19行或22行*60%]</td>
            <td colspan="2">{{ parseFloatNum(data.v35x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">FZ2</td>
            <td colspan="10">地方级收入应纳税额[本期：16行*40%或(18行+20行)*40%或22行*40%]</td>
            <td colspan="2">{{ parseFloatNum(data.v36x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">23</td>
            <td colspan="2" rowspan="3">减：民族自治地区企业所得税地方分享部分：</td>
            <td colspan="2" rowspan="3">
              <el-radio-group v-model="data.v37x2.value" style="flex-direction: column; align-items: flex-start; padding: 0 10px">
                <el-radio value="0">无</el-radio>
                <el-radio value="1">免征</el-radio>
                <el-radio value="2">减征</el-radio>
              </el-radio-group>

              <!-- <label><input type="radio" name="data_23_1_2" value="0" checked="checked" style="width: 20px" /> 无</label> <br />
              <label><input type="radio" name="data_23_1_2" value="1" style="width: 20px" /> 免征</label> <br />
              <label><input type="radio" name="data_23_1_2" value="2" style="width: 20px" /> 减征</label> -->
            </td>
            <td colspan="1" rowspan="3">减征幅度</td>
            <td colspan="2" rowspan="3">0.000000%</td>
            <td colspan="3">本期实际减免金额（FZ2*减征幅度）</td>
            <td colspan="2">{{ parseFloatNum(data.v37x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">23.1</td>
            <td colspan="3">本机构本年累计的（23行的本年累计）</td>
            <td colspan="2">{{ parseFloatNum(data.v38x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">23.2</td>
            <td colspan="3">本年累计应减免金额（总机构及分支机构的本年累计，总机构填报）</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v39x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">F23</td>
            <td colspan="10">地方级收入实际应纳税额（本期：FZ2-23）</td>
            <td colspan="2">{{ parseFloatNum(data.v40x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">24</td>
            <td colspan="10">实际应补（退）所得税额</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v41x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="13">
              <p class="text-left">谨声明：本纳税申报表是根据国家税收法律法规及相关规定填报的，是真实的、可靠的、完整的。</p>
              <p class="text-left">纳税人（签章）：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日</p>
            </td>
          </tr>
          <tr>
            <td colspan="7">经办人： 经办人身份证号： 代理机构签章： 代理机构统一社会信用代码：</td>
            <td colspan="6">受理人： 受理税务机关（章）： 受理日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 5px 0; display: flex; justify-content: flex-end">
      <span>国家税务总局监制</span>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};
const radio1 = ref("1");
const radio2 = ref("1");
function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 从业人数-季度平均值
        const v1x9 = getAverage(
          [
            [data.value.v1x1.value, data.value.v1x2.value],
            [data.value.v1x3.value, data.value.v1x4.value],
            [data.value.v1x5.value, data.value.v1x6.value],
            [data.value.v1x7.value, data.value.v1x8.value],
          ].map((item) => new Big(new Big(item[0]).plus(item[1])).div(2))
        );

        data.value.v1x9.value = Math.ceil(v1x9.toNumber());

        // 资产总额-季度平均值
        const v2x9 = getAverage(
          [
            [data.value.v2x1.value, data.value.v2x2.value],
            [data.value.v2x3.value, data.value.v2x4.value],
            [data.value.v2x5.value, data.value.v2x6.value],
            [data.value.v2x7.value, data.value.v2x8.value],
          ].map((item) => new Big(new Big(item[0]).plus(item[1])).div(2))
        );

        data.value.v2x9.value = v2x9.round(2).toNumber();
        // 7=7.1+7.2
        data.value.v13x1.value = new Big(data.value.v14x2.value).plus(data.value.v15x2.value).round(2).toNumber();
        // 8=8.1+8.2
        data.value.v16x1.value = new Big(data.value.v17x2.value).plus(data.value.v18x2.value).round(2).toNumber();
        // 10=3+4-5-6-7-8-9
        data.value.v20x1.value = new Big(data.value.v9x1.value)
          .plus(data.value.v10x1.value)
          .minus(data.value.v11x1.value)
          .minus(data.value.v12x1.value)
          .minus(data.value.v13x1.value)
          .minus(data.value.v16x1.value)
          .minus(data.value.v19x1.value)
          .round(2)
          .toNumber();
        // 12=10*11
        data.value.v22x1.value = new Big(data.value.v20x1.value).times(data.value.v21x1.value).round(2).toNumber();
        // 13.1 计算 10 * rate
        data.value.v24x2.value = new Big(data.value.v20x1.value)
          .times(getRate(data.value.v24x1.value, options3.map((item) => item.options).flat()))
          .round(2)
          .toNumber();
        // 13=13.1+13.2
        data.value.v23x1.value = new Big(data.value.v24x2.value).plus(data.value.v25x2.value).round(2).toNumber();
        // 16=12-13-14-15
        data.value.v28x1.value = new Big(data.value.v22x1.value).minus(data.value.v23x1.value).minus(data.value.v26x1.value).minus(data.value.v27x1.value).round(2).toNumber();
        // 17=18+19+20
        data.value.v29x1.value = new Big(data.value.v30x1.value).plus(data.value.v31x1.value).plus(data.value.v32x1.value).round(2).toNumber();
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

function getRate(value, options) {
  const option = options.find((item) => item.value == value);

  if (option) {
    return option.rate;
  }

  return 0;
}

function getAverage(arr = [1, 2, 3, 0]) {
  let count = 0;
  let res = 0;
  for (let i = 0; i < arr.length; i++) {
    let item = arr[i];
    if (item > 0) {
      count++;
      res = new Big(res).plus(item);
    }
  }

  if (count > 0) {
    return new Big(res).div(count);
  }

  return new Big(0);
}

const options1 = [
  // {
  //   label: " ",
  //   options: [
  //     {
  //       value: "0_1",
  //       label: " ",
  //     },
  //   ],
  // },
  {
    label: "免税收入",
    options: [
      { value: "1_1", label: "国债利息收入免征企业所得税" },
      { value: "1_2", label: "一般股息红利等权益性投资收益免征企业所得税" },
      { value: "1_3", label: "通过沪港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税" },
      { value: "1_4", label: "通过深港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税" },
      { value: "1_5", label: "创新企业CDR 取得的股息红利所得免征企业所得税" },
      { value: "1_6", label: "永续债利息收入免征企业所得税" },
      { value: "1_7", label: "符合条件的非营利组织的收入免征企业所得税" },
      { value: "1_8", label: "投资者从证券投资基金分配中取得的收入免征企业所得税" },
      { value: "1_9", label: "取得的地方政府债券利息收入免征企业所得税" },
      { value: "1_10", label: "中国清洁发展机制基金取得的收入免征企业所得税" },
      { value: "1_11", label: "中国保险保障基金有限责任公司取得的保险保障基金等收入免征企业所得税" },
      { value: "1_12", label: "中国奥委会取得北京冬奥组委支付的收入免征企业所得税" },
      { value: "1_13", label: "中国残奥委会取得北京冬奥组委分期支付的收入免征企业所得税" },
      { value: "1_14", label: "其他" },
    ],
  },
  {
    label: "减计收入",
    options: [
      { value: "2_1", label: "综合利用资源生产产品取得的收入在计算应纳税所得额时减计收入" },
      { value: "2_2", label: "金融机构取得的涉农贷款利息收入在计算应纳税所得额时减计收入" },
      { value: "2_3", label: "保险机构取得的涉农保费收入在计算应纳税所得额时减计收入" },
      { value: "2_4", label: "小额贷款公司取得的农户小额贷款利息收入在计算应纳税所得额时减计收入" },
      { value: "2_5", label: "取得铁路债券利息收入减半征收企业所得税" },
      { value: "2_6", label: "取得的社区家庭服务收入在计算应纳税所得额时减计收入" },
      { value: "2_7", label: "其他" },
    ],
  },
];

const options2 = [
  // { value: "0", label: " " },
  { value: "1", label: "从事农、林、牧、渔业项目的所得减免征收企业所得税" },
  { value: "2", label: "从事国家重点扶持的公共基础设施项目(除农村饮水工程)投资经营的所得定期减免企业所得税" },
  { value: "3", label: "从事农村饮水工程新建项目投资经营的所得定期减免企业所得税" },
  { value: "4", label: "从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税" },
  { value: "5", label: "符合条件的一般技术转让项目所得减免征收企业所得税" },
  { value: "6", label: "符合条件的中关村国家自主创新示范区特定区域技术转让项目所得减免征收企业所得税" },
  { value: "7", label: "实施清洁发展机制项目的所得定期减免企业所得税" },
  { value: "8", label: "符合条件的节能服务公司实施合同能源管理项目的所得定期减免企业所得税" },
  { value: "9", label: "线宽小于130纳米(含)的集成电路生产项目的所得减免企业所得税" },
  { value: "10", label: "线宽小于65纳米(含)或投资额超过150亿元的集成电路生产项目的所得减免企业所得税" },
  { value: "11", label: "线宽小于28纳米(含)的集成电路生产项目的所得减免企业所得税" },
  { value: "12", label: "其他" },
];

const options3 = [
  // {
  //   value: "0",
  //   label: " ",
  //   rate: 0,
  // },
  {
    value: "1",
    label: "小型微利企业",
    options: [{ value: "1_1", label: "符合条件的小型微利企业减免企业所得税", rate: 0.2 }],
  },
  {
    value: "2",
    label: "高新技术企业",
    options: [
      { value: "2_1", label: "国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税", rate: 0.15 },
      // { value: "2_2", label: "经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税%的税率征收企业所得税" },
    ],
  },
  // {
  //   value: "3",
  //   label: "软件集成电路企业(原政策继续执行至到期)",
  //   options: [
  //     { value: "3_1", label: "线宽小于0.8微米(含)的集成电路生产企业减免企业所得税" },
  //     { value: "3_2", label: "线宽小于0.25微米的集成电路生产企业减免企业所得税" },
  //     { value: "3_3", label: "投资额超过80亿元的集成电路生产企业减免企业所得税" },
  //     { value: "3_4", label: "新办集成电路设计企业减免企业所得税" },
  //     { value: "3_5", label: "符合条件的软件企业减免企业所得税" },
  //     { value: "3_6", label: "符合条件的集成电路封装测试企业定期减免企业所得税" },
  //     { value: "3_7", label: "符合条件的集成电路关键专用材料生产企业、集成电路专用设备生产企业定期减免企业所得税" },
  //     { value: "3_8", label: "线宽小于130纳米(含)的集成电路生产企业减免企业所得税" },
  //     { value: "3_9", label: "线宽小于65纳米(含)或投资额超过150亿元的集成电路生产企业减免企业所得税" },
  //   ],
  // },
  // {
  //   value: "4",
  //   label: "软件集成电路企业(新政策)",
  //   options: [
  //     { value: "4_1", label: "国家鼓励的线宽小于28纳米(含)集成电路生产企业减免企业所得税" },
  //     { value: "4_2", label: "国家鼓励的线宽小于65纳米(含)集成电路生产企业减免企业所得税" },
  //     { value: "4_3", label: "国家鼓励的线宽小于130纳米(含)集成电路生产企业减免企业所得税" },
  //     { value: "4_4", label: "国家鼓励的集成电路设计企业减免企业所得税" },
  //     { value: "4_5", label: "国家鼓励的重点集成电路设计企业减免企业所得税" },
  //     { value: "4_6", label: "国家鼓励的集成电路装备企业减免企业所得税" },
  //     { value: "4_7", label: "国家鼓励的集成电路材料企业减免企业所得税" },
  //     { value: "4_8", label: "国家鼓励的集成电路封装、测试企业减免企业所得税" },
  //     { value: "4_9", label: "国家鼓励的软件企业减免企业所得税" },
  //     { value: "4_10", label: "国家鼓励的重点软件企业减免企业所得税" },
  //   ],
  // },
  // {
  //   value: "5",
  //   label: "技术先进型服务企业",
  //   options: [
  //     { value: "5_1", label: "技术先进型服务企业(服务外包类)减按15%的税率征收企业所得税" },
  //     { value: "5_2", label: "技术先进型服务企业(服务贸易类)减按15%的税率征收企业所得税" },
  //   ],
  // },
  // {
  //   value: "6",
  //   label: "特定类型企业",
  //   options: [
  //     { value: "6_1", label: "动漫企业自主开发、生产动漫产品定期减免企业所得税" },
  //     { value: "6_2", label: "经营性文化事业单位转制为企业的免征企业所得税" },
  //     { value: "6_3", label: "符合条件的生产和装配伤残人员专门用品企业免征企业所得税" },
  //     { value: "6_4", label: "从事污染防治的第三方企业减按15%的税率征收企业所得税" },
  //   ],
  // },
  // {
  //   value: "7",
  //   label: "区域性政策",
  //   options: [
  //     { value: "7_1", label: "设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税" },
  //     { value: "7_2", label: "新疆困难地区新办企业定期减免企业所得税" },
  //     { value: "7_3", label: "新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税" },
  //     { value: "7_4", label: "广东横琴、福建平潭、深圳前海等地区的鼓励类产业企业减按15%税率征收企业所得税" },
  //     { value: "7_5", label: "上海自贸试验区临港新片区的重点产业企业减按15%的税率征收企业所得税" },
  //     { value: "7_6", label: "海南自由贸易港鼓励类企业减按15%税率征收企业所得税" },
  //   ],
  // },
  // {
  //   value: "8",
  //   label: "专项政策",
  //   options: [{ value: "8_1", label: "北京冬奥组委、北京冬奥会测试赛赛事组委会免征企业所得税" }],
  // },
  // {
  //   value: "9",
  //   label: "其他",
  //   options: [{ value: "9_1", label: "其他" }],
  // },
];

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;
}
</style>

<script>
const tableHtml = `
<table>
  <tbody>
    <tr>
      <td class="td-center" style="width: 150px">预缴方式</td>
      <td style="width: 300px"><input type="radio" id="radio1" name="type" disabled="disabled" value="1" checked="checked" /><label for="radio1">按照实际利润额预缴</label></td>
      <td style="width: 300px"><input type="radio" id="radio2" name="type" disabled="disabled" value="2" /><label for="radio2">按照上一纳税年度应纳税所得额平均额预缴</label></td>
      <td style="width: 300px"><input type="radio" id="radio3" name="type" disabled="disabled" value="3" /><label for="radio3">按照税务机关确定的其他方法预缴</label></td>
    </tr>
    <tr>
      <td class="td-center">企业类型</td>
      <td><input type="radio" id="radio1" name="cate" disabled="disabled" value="1" checked="checked" /><label for="radio1">一般企业</label></td>
      <td><input type="radio" id="radio2" name="cate" disabled="disabled" value="2" /><label for="radio2">跨地区经营汇总纳税企业 总机构</label></td>
      <td><input type="radio" id="radio3" name="cate" disabled="disabled" value="3" /><label for="radio3">跨地区经营汇总纳税企业 分支机构</label></td>
    </tr>
  </tbody>
</table>
<table class="">
  <colgroup>
    <col width="50" />
    <col />
  </colgroup>
  <thead>
    <tr class="table-head">
      <td colspan="13">优惠及附报事项有关信息</td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td colspan="3" rowspan="2" class="td-center">项目</td>
      <td colspan="2" class="td-center">一季度</td>
      <td colspan="2" class="td-center">二季度</td>
      <td colspan="2" class="td-center">三季度</td>
      <td colspan="2" class="td-center">四季度</td>
      <td colspan="2" rowspan="2" class="td-center">季度平均值</td>
    </tr>
    <tr>
      <td class="td-center">季初</td>
      <td class="td-center">季末</td>
      <td class="td-center">季初</td>
      <td class="td-center">季末</td>
      <td class="td-center">季初</td>
      <td class="td-center">季末</td>
      <td class="td-center">季初</td>
      <td class="td-center">季末</td>
    </tr>
    <tr>
      <td colspan="3" class="td-center">从业人数</td>
      <td class="td-center">
        <div validate="data_h_1_1" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_2" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_3" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_4" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_5" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_6" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_7" class="grid-input"><input type="tel" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_1_8" class="grid-input"><input type="tel" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="tel" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="3" class="td-center">资产总额（万元）</td>
      <td class="td-center">
        <div validate="data_h_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div validate="data_h_2_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="tel" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="5" class="td-center">国家限制或禁止行业</td>
      <td colspan="2" class="td-center">
        <div validate="data_h_3_1" class="grid-radio">
          <label><input type="radio" name="data_h_3_1" value="1" checked="checked" style="width: 20px" /><span>是</span></label>
          <label><input type="radio" name="data_h_3_1" value="-1" style="width: 20px" /><span>否</span></label>
        </div>
      </td>
      <td colspan="4" class="td-center">小型微利企业</td>
      <td colspan="2" class="td-center">
        <div validate="data_h_3_2" class="grid-radio">
          <label><input type="radio" name="data_h_3_2" value="1" checked="checked" style="width: 20px" /><span>是</span></label>
          <label><input type="radio" name="data_h_3_2" value="-1" style="width: 20px" /><span>否</span></label>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="td-center"><b>代码</b></td>
      <td colspan="9" class="td-center"><b>附报事项名称</b></td>
      <td colspan="2" class="td-center"><div>金额或选项</div></td>
    </tr>
    <tr>
      <td colspan="3" class="td-center">D01002</td>
      <td colspan="8">支持新型冠状病毒感染的肺炎疫情防控捐赠支出金额扣除(本年累积,元)</td>
      <td colspan="2" class="td-center">
        <div validate="data_h_4_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="3" class="td-center">K01002</td>
      <td colspan="8">扶贫捐赠支出全额扣除(本年累积,元)</td>
      <td colspan="2" class="td-center">
        <div validate="data_h_5_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="3" class="td-center">Y01001</td>
      <td colspan="8">软件集成电路企业按新政策或原政策执行优惠(单选：原政策/新政策)</td>
      <td colspan="2" class="td-center">
        <div validate="data_h_6_2" class="grid-radio">
          <label><input type="radio" name="data_h_6_2" value="1" checked="checked" style="width: 20px" /><span>原政策</span></label>
          <label><input type="radio" name="data_h_6_2" value="-1" style="width: 20px" /><span>新政策</span></label>
        </div>
      </td>
    </tr>
    <tr class="table-head">
      <td></td>
      <td colspan="10" class="td-center">预缴税款计算</td>
      <td colspan="2" class="td-center">本年累计</td>
    </tr>
    <tr>
      <td class="indent_1em">1</td>
      <td colspan="10">营业收入</td>
      <td colspan="2">
        <div validate="data_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">2</td>
      <td colspan="10">营业成本</td>
      <td colspan="2">
        <div validate="data_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">3</td>
      <td colspan="10">利润总额</td>
      <td colspan="2">
        <div validate="data_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">4</td>
      <td colspan="10">加：特定业务计算的应纳税所得额</td>
      <td colspan="2">
        <div validate="data_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">5</td>
      <td colspan="10">减：不征税收入</td>
      <td colspan="2">
        <div validate="data_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">6</td>
      <td colspan="10">减：资产加速折旧、摊销（扣除）调减额（填写 A201020）</td>
      <td colspan="2">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">7</td>
      <td colspan="8">减：免税收入、减计收入、加计扣除（7.1+7.2+…）</td>
      <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
      <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
      <td colspan="2">
        <div validate="data_7" class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">7.1</td>
      <td colspan="9">
        <div validate="data_selected" class="grid-input">
          <select name="lineSevenSelect">
            <optgroup label=""><option value="0_1"></option></optgroup>
            <optgroup label="免税收入">
              <option value="1_1">国债利息收入免征企业所得税</option>
              <option value="1_2">一般股息红利等权益性投资收益免征企业所得税</option>
              <option value="1_3">通过沪港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税</option>
              <option value="1_4">通过深港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税</option>
              <option value="1_5">创新企业CDR 取得的股息红利所得免征企业所得税</option>
              <option value="1_6">永续债利息收入免征企业所得税</option>
              <option value="1_7">符合条件的非营利组织的收入免征企业所得税</option>
              <option value="1_8">投资者从证券投资基金分配中取得的收入免征企业所得税</option>
              <option value="1_9">取得的地方政府债券利息收入免征企业所得税</option>
              <option value="1_10">中国清洁发展机制基金取得的收入免征企业所得税</option>
              <option value="1_11">中国保险保障基金有限责任公司取得的保险保障基金等收入免征企业所得税</option>
              <option value="1_12">中国奥委会取得北京冬奥组委支付的收入免征企业所得税</option>
              <option value="1_13">中国残奥委会取得北京冬奥组委分期支付的收入免征企业所得税</option>
              <option value="1_14">其他</option>
            </optgroup>
            <optgroup label="减计收入">
              <option value="2_1">综合利用资源生产产品取得的收入在计算应纳税所得额时减计收入</option>
              <option value="2_2">金融机构取得的涉农贷款利息收入在计算应纳税所得额时减计收入</option>
              <option value="2_3">保险机构取得的涉农保费收入在计算应纳税所得额时减计收入</option>
              <option value="2_4">小额贷款公司取得的农户小额贷款利息收入在计算应纳税所得额时减计收入</option>
              <option value="2_5">取得铁路债券利息收入减半征收企业所得税</option>
              <option value="2_6">取得的社区家庭服务收入在计算应纳税所得额时减计收入</option>
              <option value="2_7">其他</option>
            </optgroup>
          </select>
        </div>
      </td>
      <td class="td-center">
        <div class="grid-radio">
          <label><input type="checkbox" name="lineSeven" data_id="0" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">7.2</td>
      <td colspan="9">
        <div validate="data_selected" class="grid-input">
          <select name="lineSevenSelect">
            <optgroup label=""><option value="0_1"></option></optgroup>
            <optgroup label="免税收入">
              <option value="1_1">国债利息收入免征企业所得税</option>
              <option value="1_2">一般股息红利等权益性投资收益免征企业所得税</option>
              <option value="1_3">通过沪港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税</option>
              <option value="1_4">通过深港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税</option>
              <option value="1_5">创新企业CDR 取得的股息红利所得免征企业所得税</option>
              <option value="1_6">永续债利息收入免征企业所得税</option>
              <option value="1_7">符合条件的非营利组织的收入免征企业所得税</option>
              <option value="1_8">投资者从证券投资基金分配中取得的收入免征企业所得税</option>
              <option value="1_9">取得的地方政府债券利息收入免征企业所得税</option>
              <option value="1_10">中国清洁发展机制基金取得的收入免征企业所得税</option>
              <option value="1_11">中国保险保障基金有限责任公司取得的保险保障基金等收入免征企业所得税</option>
              <option value="1_12">中国奥委会取得北京冬奥组委支付的收入免征企业所得税</option>
              <option value="1_13">中国残奥委会取得北京冬奥组委分期支付的收入免征企业所得税</option>
              <option value="1_14">其他</option>
            </optgroup>
            <optgroup label="减计收入">
              <option value="2_1">综合利用资源生产产品取得的收入在计算应纳税所得额时减计收入</option>
              <option value="2_2">金融机构取得的涉农贷款利息收入在计算应纳税所得额时减计收入</option>
              <option value="2_3">保险机构取得的涉农保费收入在计算应纳税所得额时减计收入</option>
              <option value="2_4">小额贷款公司取得的农户小额贷款利息收入在计算应纳税所得额时减计收入</option>
              <option value="2_5">取得铁路债券利息收入减半征收企业所得税</option>
              <option value="2_6">取得的社区家庭服务收入在计算应纳税所得额时减计收入</option>
              <option value="2_7">其他</option>
            </optgroup>
          </select>
        </div>
      </td>
      <td class="td-center">
        <div class="grid-radio">
          <label><input type="checkbox" name="lineSeven" data_id="1" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">8</td>
      <td colspan="8">减：所得减免（8.1+8.2+…）</td>
      <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
      <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
      <td colspan="2">
        <div validate="data_8" class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">8.1</td>
      <td colspan="9">
        <div validate="data_selected" class="grid-input">
          <select name="lineEightSelect">
            <option value="0"></option>
            <option value="1">从事农、林、牧、渔业项目的所得减免征收企业所得税</option>
            <option value="2">从事国家重点扶持的公共基础设施项目(除农村饮水工程)投资经营的所得定期减免企业所得税</option>
            <option value="3">从事农村饮水工程新建项目投资经营的所得定期减免企业所得税</option>
            <option value="4">从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税</option>
            <option value="5">符合条件的一般技术转让项目所得减免征收企业所得税</option>
            <option value="6">符合条件的中关村国家自主创新示范区特定区域技术转让项目所得减免征收企业所得税</option>
            <option value="7">实施清洁发展机制项目的所得定期减免企业所得税</option>
            <option value="8">符合条件的节能服务公司实施合同能源管理项目的所得定期减免企业所得税</option>
            <option value="9">线宽小于130纳米(含)的集成电路生产项目的所得减免企业所得税</option>
            <option value="10">线宽小于65纳米(含)或投资额超过150亿元的集成电路生产项目的所得减免企业所得税</option>
            <option value="11">线宽小于28纳米(含)的集成电路生产项目的所得减免企业所得税</option>
            <option value="12">其他</option>
          </select>
        </div>
      </td>
      <td class="td-center">
        <div class="grid-radio">
          <label><input type="checkbox" name="lineEight" data_id="0" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">8.2</td>
      <td colspan="9">
        <div validate="data_selected" class="grid-input">
          <select name="lineEightSelect">
            <option value="0"></option>
            <option value="1">从事农、林、牧、渔业项目的所得减免征收企业所得税</option>
            <option value="2">从事国家重点扶持的公共基础设施项目(除农村饮水工程)投资经营的所得定期减免企业所得税</option>
            <option value="3">从事农村饮水工程新建项目投资经营的所得定期减免企业所得税</option>
            <option value="4">从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税</option>
            <option value="5">符合条件的一般技术转让项目所得减免征收企业所得税</option>
            <option value="6">符合条件的中关村国家自主创新示范区特定区域技术转让项目所得减免征收企业所得税</option>
            <option value="7">实施清洁发展机制项目的所得定期减免企业所得税</option>
            <option value="8">符合条件的节能服务公司实施合同能源管理项目的所得定期减免企业所得税</option>
            <option value="9">线宽小于130纳米(含)的集成电路生产项目的所得减免企业所得税</option>
            <option value="10">线宽小于65纳米(含)或投资额超过150亿元的集成电路生产项目的所得减免企业所得税</option>
            <option value="11">线宽小于28纳米(含)的集成电路生产项目的所得减免企业所得税</option>
            <option value="12">其他</option>
          </select>
        </div>
      </td>
      <td class="td-center">
        <div class="grid-radio">
          <label><input type="checkbox" name="lineEight" data_id="1" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">9</td>
      <td colspan="10">减：弥补以前年度亏损</td>
      <td colspan="2">
        <div validate="data_9" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">10</td>
      <td colspan="10">实际利润额（3+4-5-6-7-8-9）\ 按照上一纳税年度应纳税所得额平均额确定的应纳税所得额</td>
      <td colspan="2">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">11</td>
      <td colspan="10">税率(25%)</td>
      <td colspan="2">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">12</td>
      <td colspan="10">应纳所得税额（10×11）</td>
      <td colspan="2">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">13</td>
      <td colspan="8">减：减免所得税额（13.1+13.2+…）</td>
      <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
      <td class="td-center"><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
      <td colspan="2">
        <div validate="data_13" class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">13.1</td>
      <td colspan="9">
        <div validate="data_selected" class="grid-input">
          <select name="lineThirteenSelect">
            <optgroup label="" value="0"></optgroup>
            <optgroup label="小型微利企业" value="1"><option value="1_1">符合条件的小型微利企业减免企业所得税</option></optgroup>
            <optgroup label="高新技术企业" value="2">
              <option iscomputed="true" value="2_1">国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税</option>
              <option value="2_2">经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税</option>
            </optgroup>
            <optgroup label="软件集成电路企业(原政策继续执行至到期)" value="3">
              <option value="3_1">线宽小于0.8微米(含)的集成电路生产企业减免企业所得税</option>
              <option value="3_2">线宽小于0.25微米的集成电路生产企业减免企业所得税</option>
              <option value="3_3">投资额超过80亿元的集成电路生产企业减免企业所得税</option>
              <option value="3_4">新办集成电路设计企业减免企业所得税</option>
              <option value="3_5">符合条件的软件企业减免企业所得税</option>
              <option value="3_6">符合条件的集成电路封装测试企业定期减免企业所得税</option>
              <option value="3_7">符合条件的集成电路关键专用材料生产企业、集成电路专用设备生产企业定期减免企业所得税</option>
              <option value="3_8">线宽小于130纳米(含)的集成电路生产企业减免企业所得税</option>
              <option value="3_9">线宽小于65纳米(含)或投资额超过150亿元的集成电路生产企业减免企业所得税</option>
            </optgroup>
            <optgroup label="软件集成电路企业(新政策)" value="4">
              <option value="4_1">国家鼓励的线宽小于28纳米(含)集成电路生产企业减免企业所得税</option>
              <option value="4_2">国家鼓励的线宽小于65纳米(含)集成电路生产企业减免企业所得税</option>
              <option value="4_3">国家鼓励的线宽小于130纳米(含)集成电路生产企业减免企业所得税</option>
              <option value="4_4">国家鼓励的集成电路设计企业减免企业所得税</option>
              <option value="4_5">国家鼓励的重点集成电路设计企业减免企业所得税</option>
              <option value="4_6">国家鼓励的集成电路装备企业减免企业所得税</option>
              <option value="4_7">国家鼓励的集成电路材料企业减免企业所得税</option>
              <option value="4_8">国家鼓励的集成电路封装、测试企业减免企业所得税</option>
              <option value="4_9">国家鼓励的软件企业减免企业所得税</option>
              <option value="4_10">国家鼓励的重点软件企业减免企业所得税</option>
            </optgroup>
            <optgroup label="技术先进型服务企业" value="5">
              <option value="5_1">技术先进型服务企业(服务外包类)减按15%的税率征收企业所得税</option>
              <option value="5_2">技术先进型服务企业(服务贸易类)减按15%的税率征收企业所得税</option>
            </optgroup>
            <optgroup label="特定类型企业" value="6">
              <option value="6_1">动漫企业自主开发、生产动漫产品定期减免企业所得税</option>
              <option value="6_2">经营性文化事业单位转制为企业的免征企业所得税</option>
              <option value="6_3">符合条件的生产和装配伤残人员专门用品企业免征企业所得税</option>
              <option value="6_4">从事污染防治的第三方企业减按15%的税率征收企业所得税</option>
            </optgroup>
            <optgroup label="区域性政策" value="7">
              <option value="7_1">设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税</option>
              <option value="7_2">新疆困难地区新办企业定期减免企业所得税</option>
              <option value="7_3">新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税</option>
              <option value="7_4">广东横琴、福建平潭、深圳前海等地区的鼓励类产业企业减按15%税率征收企业所得税</option>
              <option value="7_5">上海自贸试验区临港新片区的重点产业企业减按15%的税率征收企业所得税</option>
              <option value="7_6">海南自由贸易港鼓励类企业减按15%税率征收企业所得税</option>
            </optgroup>
            <optgroup label="专项政策" value="8"><option value="8_1">北京冬奥组委、北京冬奥会测试赛赛事组委会免征企业所得税</option></optgroup>
            <optgroup label="其他" value="9"><option value="9_1">其他</option></optgroup>
          </select>
        </div>
      </td>
      <td class="td-center">
        <div class="grid-radio">
          <label><input type="checkbox" name="lineThirteen" data_id="0" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">13.2</td>
      <td colspan="9">
        <div validate="data_selected" class="grid-input">
          <select name="lineThirteenSelect">
            <optgroup label="" value="0"></optgroup>
            <optgroup label="小型微利企业" value="1"><option value="1_1">符合条件的小型微利企业减免企业所得税</option></optgroup>
            <optgroup label="高新技术企业" value="2">
              <option iscomputed="true" value="2_1">国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税</option>
              <option value="2_2">经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税</option>
            </optgroup>
            <optgroup label="软件集成电路企业(原政策继续执行至到期)" value="3">
              <option value="3_1">线宽小于0.8微米(含)的集成电路生产企业减免企业所得税</option>
              <option value="3_2">线宽小于0.25微米的集成电路生产企业减免企业所得税</option>
              <option value="3_3">投资额超过80亿元的集成电路生产企业减免企业所得税</option>
              <option value="3_4">新办集成电路设计企业减免企业所得税</option>
              <option value="3_5">符合条件的软件企业减免企业所得税</option>
              <option value="3_6">符合条件的集成电路封装测试企业定期减免企业所得税</option>
              <option value="3_7">符合条件的集成电路关键专用材料生产企业、集成电路专用设备生产企业定期减免企业所得税</option>
              <option value="3_8">线宽小于130纳米(含)的集成电路生产企业减免企业所得税</option>
              <option value="3_9">线宽小于65纳米(含)或投资额超过150亿元的集成电路生产企业减免企业所得税</option>
            </optgroup>
            <optgroup label="软件集成电路企业(新政策)" value="4">
              <option value="4_1">国家鼓励的线宽小于28纳米(含)集成电路生产企业减免企业所得税</option>
              <option value="4_2">国家鼓励的线宽小于65纳米(含)集成电路生产企业减免企业所得税</option>
              <option value="4_3">国家鼓励的线宽小于130纳米(含)集成电路生产企业减免企业所得税</option>
              <option value="4_4">国家鼓励的集成电路设计企业减免企业所得税</option>
              <option value="4_5">国家鼓励的重点集成电路设计企业减免企业所得税</option>
              <option value="4_6">国家鼓励的集成电路装备企业减免企业所得税</option>
              <option value="4_7">国家鼓励的集成电路材料企业减免企业所得税</option>
              <option value="4_8">国家鼓励的集成电路封装、测试企业减免企业所得税</option>
              <option value="4_9">国家鼓励的软件企业减免企业所得税</option>
              <option value="4_10">国家鼓励的重点软件企业减免企业所得税</option>
            </optgroup>
            <optgroup label="技术先进型服务企业" value="5">
              <option value="5_1">技术先进型服务企业(服务外包类)减按15%的税率征收企业所得税</option>
              <option value="5_2">技术先进型服务企业(服务贸易类)减按15%的税率征收企业所得税</option>
            </optgroup>
            <optgroup label="特定类型企业" value="6">
              <option value="6_1">动漫企业自主开发、生产动漫产品定期减免企业所得税</option>
              <option value="6_2">经营性文化事业单位转制为企业的免征企业所得税</option>
              <option value="6_3">符合条件的生产和装配伤残人员专门用品企业免征企业所得税</option>
              <option value="6_4">从事污染防治的第三方企业减按15%的税率征收企业所得税</option>
            </optgroup>
            <optgroup label="区域性政策" value="7">
              <option value="7_1">设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税</option>
              <option value="7_2">新疆困难地区新办企业定期减免企业所得税</option>
              <option value="7_3">新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税</option>
              <option value="7_4">广东横琴、福建平潭、深圳前海等地区的鼓励类产业企业减按15%税率征收企业所得税</option>
              <option value="7_5">上海自贸试验区临港新片区的重点产业企业减按15%的税率征收企业所得税</option>
              <option value="7_6">海南自由贸易港鼓励类企业减按15%税率征收企业所得税</option>
            </optgroup>
            <optgroup label="专项政策" value="8"><option value="8_1">北京冬奥组委、北京冬奥会测试赛赛事组委会免征企业所得税</option></optgroup>
            <optgroup label="其他" value="9"><option value="9_1">其他</option></optgroup>
          </select>
        </div>
      </td>
      <td class="td-center">
        <div class="grid-radio">
          <label><input type="checkbox" name="lineThirteen" data_id="1" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">14</td>
      <td colspan="10">减：本年实际已缴纳所得税额</td>
      <td colspan="2">
        <div validate="data_14" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">15</td>
      <td colspan="10">减：特定业务预缴（征）所得税额</td>
      <td colspan="2">
        <div validate="data_15" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">16</td>
      <td colspan="10">本期应补（退）所得税额（12-13-14-15）\税务机关确定的本期应纳所得税额</td>
      <td colspan="2">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr class="table-head">
      <td colspan="13" class="td-center">汇总纳税企业总分机构税款计算</td>
    </tr>
    <tr>
      <td class="indent_1em">17</td>
      <td colspan="2" rowspan="4" class="td-center">总机构</td>
      <td colspan="8">总机构本期分摊应补（退）所得税额（18+19+20）</td>
      <td colspan="2">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">18</td>
      <td colspan="8">其中：总机构分摊应补（退）所得税额（16×总机构分摊比例____%）</td>
      <td colspan="2">
        <div validate="data_18" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">19</td>
      <td colspan="8" class="indent_2em">财政集中分配应补（退）所得税额（16×财政集中分配比例____%）</td>
      <td colspan="2">
        <div validate="data_19" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">20</td>
      <td colspan="8" class="indent_2em">总机构具有主体生产经营职能的部门分摊所得税额（16×全部分支机构分摊比例____% ×总机构具有主体生产经营职能部门分摊比例____%)</td>
      <td colspan="2">
        <div validate="data_20" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">21</td>
      <td colspan="2" rowspan="2" class="td-center">分支机构</td>
      <td colspan="8">分支机构本期分摊比例</td>
      <td colspan="2">
        <div validate="data_21" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">22</td>
      <td colspan="8">分支机构本期分摊应补（退）所得税额</td>
      <td colspan="2">
        <div validate="data_22" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr class="table-head">
      <td colspan="13" class="td-center">实际缴纳企业所得税计算</td>
    </tr>
    <tr>
      <td class="indent_1em">FZ1</td>
      <td colspan="10">中央级收入实际应纳税额[本期：16行*60%或（18行+20行）*60% +19行或22行*60%]</td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">FZ2</td>
      <td colspan="10">地方级收入应纳税额[本期：16行*40%或(18行+20行)*40%或22行*40%]</td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">23</td>
      <td colspan="2" rowspan="3">减：民族自治地区企业所得税地方分享部分：</td>
      <td colspan="2" rowspan="3">
        <div validate="data_23_1_2" class="grid-radio">
          <label><input type="radio" name="data_23_1_2" value="0" checked="checked" style="width: 20px" /> <span>无</span></label> <br />
          <label><input type="radio" name="data_23_1_2" value="1" style="width: 20px" /> <span>免征</span></label> <br />
          <label><input type="radio" name="data_23_1_2" value="2" style="width: 20px" /> <span>减征</span></label>
        </div>
      </td>
      <td colspan="1" rowspan="3">减征幅度</td>
      <td colspan="2" rowspan="3">0.000000%</td>
      <td colspan="3">本期实际减免金额（FZ2*减征幅度）</td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">23.1</td>
      <td colspan="3">本机构本年累计的（23行的本年累计）</td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">23.2</td>
      <td colspan="3">本年累计应减免金额（总机构及分支机构的本年累计，总机构填报）</td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">F23</td>
      <td colspan="10">地方级收入实际应纳税额（本期：FZ2-23）</td>
      <td colspan="2">
        <div class="grid-input"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_1em">24</td>
      <td colspan="10">实际应补（退）所得税额</td>
      <td colspan="2">
        <div validate="data_24" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="13">
        <div class="text-area">
          <p class="text-left">谨声明：本纳税申报表是根据国家税收法律法规及相关规定填报的，是真实的、可靠的、完整的。</p>
          <p class="text-left">纳税人（签章）：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日</p>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="7">
        <div class="text-area">
          <div class="row"><div class="col-xs-12">经办人：</div></div>
          <div class="row">
            <div class="col-xs-6">经办人身份证号：</div>
            <div class="col-xs-6">代理机构签章：</div>
          </div>
          <div class="row"><div class="col-xs-12">代理机构统一社会信用代码：</div></div>
        </div>
      </td>
      <td colspan="6">
        <div class="text-area">
          <div class="row"><div class="col-xs-12">受理人：</div></div>
          <div class="row">
            <div class="col-xs-6">受理税务机关（章）：</div>
            <div class="col-xs-6">受理日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日</div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
